import {$authHost} from "./index";
import {API_ENDPOINTS} from "../utils/urls";


export async function groupsGetApi(){
    try {
        return await $authHost.get(API_ENDPOINTS.GROUP);
    } catch (error: any) {
        return error;
    }
}

export async function groupGetApi(id: number | string){
    try {
        return await $authHost.get(API_ENDPOINTS.GROUP + `/${id}`);
    } catch (error: any) {
        return error;
    }
}

export async function groupCreateApi(data: { name: string, color?: string | null }){
    try {
        return await $authHost.post(API_ENDPOINTS.GROUP, data);
    } catch (error: any) {
        return error;
    }
}

export async function groupUpdateApi(id: number | string, data: { name?: string, color?: string | null }){
    try {
        return await $authHost.put(API_ENDPOINTS.GROUP + `/${id}`, data);
    } catch (error: any) {
        return error;
    }
}

export async function groupDeleteApi(id: number | string){
    try {
        return await $authHost.delete(API_ENDPOINTS.GROUP + `/${id}`);
    } catch (error: any) {
        return error;
    }
}

export async function groupAddCompanyApi(groupId: number | string, companyId: number | string){
    try {
        return await $authHost.put(API_ENDPOINTS.GROUP + `/${groupId}/companies/${companyId}`);
    } catch (error: any) {
        return error;
    }
}

export async function groupRemoveCompanyApi(groupId: number | string, companyId: number | string){
    try {
        return await $authHost.delete(API_ENDPOINTS.GROUP + `/${groupId}/companies/${companyId}`);
    } catch (error: any) {
        return error;
    }
}
